import Home from '@/views/Default/Home';
import Parameter from '@/views/Parameter/edit';
import Reset from '@/views/Authentification/reset';
import Request from '@/views/Authentification/request';
import MemorialShow from '@/views/Memorial/show';
import MemorialIndex from '@/views/Memorial/index';
import BookIndex from '@/views/Book/index';
import CandleIndex from '@/views/Candle/index';
import PhotoIndex from '@/views/Photo/index';
import QrcodeRedirect from '@/components/QrcodeRedirect';
import SubscriptionIndex from '@/views/Subscription/index';
import VideoIndex from '@/views/Video/index';
import Contact from '@/views/Default/Contact';
import Cgv from '@/views/Default/Cgv';
import Faq from '@/views/Default/Faq';
import Partner from '@/views/Default/Partner';
import BecomePrescriber from '@/views/Default/BecomePrescriber';
import Notifications from '@/views/Default/Notifications';
import NotFound from '@/views/NotFound';
import _ from '@triotech/vue-core/src/lib/plugins/_';

export default [{
  path: '/',
  name: 'home',
  component: Home,
}, {
  path: '/reset/request',
  name: 'password.request',
  component: Request,
}, {
  path: '/reset/change/:token',
  name: 'password.reset',
  component: Reset,
  props: _.propsValidator.bind(_, Reset),
}, {
  path: '/contact',
  name: 'contact',
  component: Contact,
  props: _.propsValidator.bind(_, Contact),
}, {
  path: '/cgv',
  name: 'cgv',
  component: Cgv,
  props: _.propsValidator.bind(_, Cgv),
}, {
  path: '/faq',
  name: 'faq',
  component: Faq,
  props: _.propsValidator.bind(_, Faq),
}, {
  path: '/partner',
  name: 'partner',
  component: Partner,
  props: _.propsValidator.bind(_, Partner),
}, {
  path: '/become_prescriber',
  name: 'become_prescriber',
  component: BecomePrescriber,
  props: _.propsValidator.bind(_, BecomePrescriber),
}, {
  path: '/notifications',
  name: 'notifications',
  component: Notifications,
}, {
  path: '/parameter',
  name: 'parameter',
  component: Parameter,
  props: _.propsValidator.bind(_, Parameter),
}, {
  path: '/memorial/:id/',
  name: 'memorial.show',
  component: MemorialShow,
  props: _.propsValidator.bind(_, MemorialShow),
}, {
  path: '/memorial/:search/list',
  name: 'memorial.index',
  component: MemorialIndex,
  props: _.propsValidator.bind(_, MemorialIndex),
}, {
  path: '/memorial/:id/book',
  name: 'book.index',
  component: BookIndex,
  props: _.propsValidator.bind(_, BookIndex),
}, {
  path: '/memorial/:id/candle',
  name: 'candle.index',
  component: CandleIndex,
  props: _.propsValidator.bind(_, CandleIndex),
}, {
  path: '/memorial/:id/photo',
  name: 'photo.index',
  component: PhotoIndex,
  props: _.propsValidator.bind(_, PhotoIndex),
}, {
  path: '/memorial/:id/video',
  name: 'video.index',
  component: VideoIndex,
  props: _.propsValidator.bind(_, VideoIndex),
}, {
  path: '/memorial/:id/subscription',
  name: 'subscription.index',
  component: SubscriptionIndex,
  props: _.propsValidator.bind(_, SubscriptionIndex),
}, {
  path: '/qr/:id/',
  name: 'qrcode.redirect',
  component: QrcodeRedirect,
  props: _.propsValidator.bind(_, QrcodeRedirect),
}, {
  path: '/404/',
  name: 'triotech.front.not_found',
  component: NotFound,
}];



// WEBPACK FOOTER //
// ./config/routing.js